import { useMemo, useState } from "react";
import { SortOrder } from "../../common/constants";
import {
    InvoiceSort,
    InvoiceByCounterpartySortValue,
} from "../../common/types/invoice";

export const DEFAULT_SORT = InvoiceByCounterpartySortValue.OPEN_DESC;

export interface SortByCounterparty {
    currentSort: InvoiceByCounterpartySortValue;
    handleSortChange: (value: InvoiceByCounterpartySortValue) => void;
    sortExpression: InvoiceSort | undefined;
}

export const getSortExpression = (sort: InvoiceByCounterpartySortValue) => {
    switch (sort) {
        case InvoiceByCounterpartySortValue.COUNTERPARTY_ASC:
            return {
                field: "counterpartyId",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.COUNTERPARTY_DESC:
            return {
                field: "counterpartyId",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.NOT_YET_DUE_ASC:
            return {
                field: "notYetDue",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.NOT_YET_DUE_DESC:
            return {
                field: "notYetDue",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_1_30_ASC:
            return {
                field: "pastDue1To30",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_1_30_DESC:
            return {
                field: "pastDue1To30",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_31_60_ASC:
            return {
                field: "pastDue31To60",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_31_60_DESC:
            return {
                field: "pastDue31To60",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_61_PLUS_ASC:
            return {
                field: "pastDue61Plus",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.PAST_DUE_61_PLUS_DESC:
            return {
                field: "pastDue61Plus",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.PAID_ASC:
            return {
                field: "paid",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.PAID_DESC:
            return {
                field: "paid",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.INVOICES_COUNT_ASC:
            return {
                field: "invoiceCount",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.INVOICES_COUNT_DESC:
            return {
                field: "invoiceCount",
                order: SortOrder.DESC,
            };
        case InvoiceByCounterpartySortValue.OPEN_ASC:
            return {
                field: "open",
                order: SortOrder.ASC,
            };
        case InvoiceByCounterpartySortValue.OPEN_DESC:
        default:
            return {
                field: "open",
                order: SortOrder.DESC,
            };
    }
};

export function useSortByCounterparty(
    defaultSort: InvoiceByCounterpartySortValue = DEFAULT_SORT,
): SortByCounterparty {
    const [currentSort, setCurrentSort] =
        useState<InvoiceByCounterpartySortValue>(defaultSort);

    const sortExpression: InvoiceSort | undefined = useMemo(
        () => getSortExpression(currentSort),
        [currentSort],
    );

    return {
        currentSort,
        handleSortChange: setCurrentSort,
        sortExpression,
    };
}
